const headers = {
  viewer: [
    'Round name',
    'Initial agreement date',
    'Conversion date',
    'Sale date',
    'Investment',
    'Fair value',
    'Gain/(loss)',
    'MOIC',
    'Irr',
    'Fund shares',
    'Total shares from this class',
    'Current holding %',
    'Original PPS',
    'Valuated/sale PPS',
    'Pre-money',
    'Total round',
    'Post-money',
    'Holding after round %',
    'Advance investment / (commitment to invest)',
    'Lead investor',
    'Comment',
  ],
  admin: [
    'Preferred?',
    'Initial?',
    'Exercised?',
    'Valuate others?',
    'Manual fair value',
    'Fund\'s shares after round',
    'Manual valuated PPS',
    'Company valuation (TAS * PPS)',
    'Historic shares after round',
  ],
};

/**
 * Get table headers for viewer or admin.
 *
 * @param isAdmin If user is in admin mode.
 * @returns array of table headers.
 */
export const getHeaders = () => {
  const { viewer } = headers;
  return viewer;
};
